/* eslint-disable max-len */
export const droplets = [
    'm.521.992s.166.057.304-.134.262-.444.094-.603C.75.097.273-.082.09.041c-.183.123-.001.793.431.951',
    'm.852.126c-.024,0-.048.006-.073.02-.129.071-.419.078-.419.078-.102,0-.367-.003-.352.258.015.26.333.393.553.363.22-.03.396-.25.438-.446.005-.025.008-.049.008-.071v-.002c0-.119-.071-.199-.156-.199',
    'm.552,0c-.108.009-.167.031-.297.228-.131.197-.171.638.259.755s.574-.428.435-.643C.825.149.66-.009.552,0',
    'm0,.427S0,.214.352.116c.352-.098.668.096.647.475-.022.379-.532.363-.729.246C.074.719-.005.579,0,.427',
    'm.762,1c-.055,0-.151-.047-.174-.234-.018-.147-.112-.234-.155-.358-.049-.144-.033-.302.134-.378.245-.112.437.101.433.486-.004.385-.183.484-.238.484',
];
/* eslint-enable max-len */
